import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getNotificationPrioritySummary } from '../../api/notificationAPI';

const getBootstrapHex = (colorName) => {
  switch (colorName.toLowerCase()) {
    case 'primary': return '487fff';
    case 'secondary': return '737373';
    case 'success': return '22c55e';
    case 'danger': return 'dc2626';
    case 'warning': return 'eab308';
    case 'info': return '0dcaf0';
    case 'light': return 'f8f9fa';
    case 'dark': return '212529';
    case 'alert': return 'fd7e14';
    default: return 'adb5bd';
  }
};

const NotificationsPriorityChart = () => {
  const [chartSeries, setChartSeries] = useState([]);
  const [chartOptions, setChartOptions] = useState({});
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getNotificationPrioritySummary();
      setData(result);

      const labels = result.map(r => r.name);
      const counts = result.map(r => Number(r.count));
      const colors = result.map(r => `#${getBootstrapHex(r.colour)}`);

      setChartSeries(counts);
      setChartOptions({
        labels,
        colors,
        chart: { type: 'donut' },
        legend: { show: false },
        dataLabels: { enabled: false },
        tooltip: {
          y: { formatter: (val) => `${val} notifications` }
        }
      });
    };

    fetchData();
  }, []);

  return (
    <div className="col-xxl-4">
      <div className="card h-100 radius-8 border-0">
        <div className="card-body p-24 d-flex flex-column justify-content-between gap-8">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mb-20">
            <h6 className="mb-2 fw-bold text-lg mb-0">Notifications By Priority</h6>
          </div>
          <div id="notificationPriorityChart" className="margin-16-minus y-value-left" />
          <ReactApexChart options={chartOptions} series={chartSeries} type="donut" height={270} />
          <ul className="d-flex flex-wrap align-items-center justify-content-between mt-3 gap-3">
            {data.map((item, index) => (
              <li key={index} className="d-flex flex-column gap-8">
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="w-12-px h-12-px rounded-circle"
                    style={{ backgroundColor: `#${getBootstrapHex(item.colour)}` }}
                  />
                  <span className="text-secondary-light text-sm fw-semibold">
                    {item.name}
                  </span>
                </div>
                <span className="text-primary-light fw-bold">{item.count}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotificationsPriorityChart;
